module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_More_16"],"path":[{"$":{"d":"M5,10H1V6H5Zm5-4H6v4h4Zm5,0H11v4h4Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_More_16.svg
// module id = q864
// module chunks = 1